import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { KapOrgIcon2, FailedPayment, BackIconWhiteColor } from "../../assets/icons";
import { Button } from "antd";
import "./style.scss";
import { useTranslation } from "../../i18n/LanguageContext";

const FailedPaymentInfo = () => {
   const { t } = useTranslation();
   const navigate = useNavigate();

   return (
      <div
         className="full-page-background"
         style={{
            backgroundImage: `url(${toAbsoluteUrl("/media/bg/loginbackground.svg")})`
         }}
      >
         <Link to="/" className="logo-link">
            <img alt="Logo" className="logo" src={KapOrgIcon2} />
         </Link>
         <div className="centered-box">
            <img src={FailedPayment} alt="FailedPayment" />
            <h2>{t("purchase-failed-title")}</h2>
            <p>{t("purchase-failed-description")}</p>
            <span>{t("apologize-inconvenience-text")}</span>
            <Button
               className="back-to-payment-info-button"
               htmlType="submit"
               style={{ width: "fit-content", color: "#fff" }}
               onClick={() => navigate("/admin/payment-information")}
            >
               <div className="button-info">
                  <img src={BackIconWhiteColor} alt="BackIconWhiteColor" />
                  <div className="back-to-payment-info-text">{t("go-back-to-payment-info-text")}</div>
               </div>
            </Button>
         </div>
      </div>
   );
};

export default FailedPaymentInfo;
